module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0058.jpg?v=737db2ff";